import { IJobRunner, JobDtoType } from '../index';


export type JobTriggeredResultType = Pick<JobDtoType, 'jobId' | 'jobStatus' | 'jobType'>;
export type JobFinishedResultType = Omit<JobDtoType, 'description'>;

export class JobMapper {
    public static toDto(job: IJobRunner): JobDtoType & {description: string} {
        return {
            jobId: job.id,
            jobStatus: job.getStatus(),
            jobType: job.type,
            jobDetails: job.getDetails(),
            result: job.getResult(),
            description: job.description
        };
    }

    public static toJobTriggeredDto(job: IJobRunner): JobTriggeredResultType {
        return {
            jobId: job.id,
            jobStatus: job.getStatus(),
            jobType: job.type
        };
    }

    public static toJobFinishedDto(job: IJobRunner): JobFinishedResultType {
        return {
            jobId: job.id,
            jobStatus: job.getStatus(),
            jobType: job.type,
            jobDetails: job.getDetails(),
            result: job.getResult()
        };
    }

    public static dtoToTriggeredResultType(job: JobDtoType): JobTriggeredResultType {
        const jobResult = { ...job };
        delete jobResult.result;

        return jobResult;
    }
}
